<template>
  <div>
    <Intro />

        <BeeHeroPack />

    <About />
    <AboutBee />

  </div>
</template>

<script>
import Intro from "./Intro.vue";
import About from "./About.vue";
import AboutBee from "./AboutBee.vue";
import BeeHeroPack from "./BeeHeroPack.vue";

export default {
  name: "MainPage",
  data() {
    return {
      title: "home page",
    };
  },
  components: {
    Intro,
    About,
    AboutBee,
    BeeHeroPack,
  },
};
</script>
